<template>
  <GrayHexContainer class="py-12 px-8">
    <h2 class="text-23 font-bold mb-2 text-center">Meet Your New HR Manager</h2>
    <div
      class="flex flex-col sm:flex-row sm:items-center justify-center max-w-full mx-auto w-75 sm:w-auto"
    >
      <EmployeeDropdown
        class="sm:w-75 mb-3 sm:mb-0 sm:mr-3 max-w-full"
        :is-invalid="isInvalid"
        @input="handleInput"
      />

      <BaseButton
        size="large"
        class="block w-full sm:w-auto"
        @click="handleSubmit"
      >
        Try Bambee Now
      </BaseButton>
    </div>
  </GrayHexContainer>
</template>

<script>
import { ref, useRoute, useRouter } from '@nuxtjs/composition-api';
import { BaseButton } from '@bambeehr/pollen';

import GrayHexContainer from '@/components/GrayHexContainer';
import EmployeeDropdown from '@/components/EmployeeDropdown';
import SelfServicePages from '@/modules/SelfServiceRegistration/constants/SelfServicePages';
import useRegistration, {
  RegistrationStateNames,
} from '@/modules/SelfServiceRegistration/hooks/useRegistration';
import selfCheckout from '@/constants/SelfCheckout';

export default {
  components: { BaseButton, GrayHexContainer, EmployeeDropdown },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isInvalid = ref(false);
    const { updateRegistration, state } = useRegistration();

    const handleInput = () => {
      isInvalid.value = false;
    };

    const handleSubmit = () => {
      if (!state.numOfEmployees) {
        isInvalid.value = true;
        return;
      }
      updateRegistration({
        [RegistrationStateNames.FUNNEL]: selfCheckout,
        [RegistrationStateNames.PAGE_REGISTERED_ON]: `${window.location.origin}${route.value.path}`,
      });
      router.push(`/registration/${SelfServicePages[0].slug}`);
    };
    return {
      handleInput,
      handleSubmit,
      isInvalid,
    };
  },
};
</script>
